import React from "react";
import { Table, Input, Button, Select, Tooltip } from "antd";
import {
  COMMON_CONSTANT,
  INPUT_TYPE,
  lang,
  MODE_SCREEN,
  STYLE,
  TYPE_INPUT,
} from "../../constants/common.const";
import { renderOption } from "../../constants/utils";
import { useSelector } from "react-redux";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { filterEmptyDataSource, isEmptyData } from "../../utils/helper";
const inspectionFryquencyOptions = [
  {
    value: "日",
    key: "1",
  },
  {
    value: "週",
    key: "2",
  },
  {
    value: "月",
    key: "3",
  },
  {
    value: "年",
    key: "4",
  },
];
const inputFormatOptions = [
  {
    value: "数字",
    key: "数字",
  },
  {
    value: "選択",
    key: "選択",
  },
  {
    value: "文字",
    key: "文字",
  },
  {
    value: "無/有",
    key: "無/有",
  },
  {
    value: "備考",
    key: "備考",
  },
];
const EquipmentListItem = ({
  mode = MODE_SCREEN.VIEW,
  dataSource = [],
  setDataSource = () => {},
  clickSave,
  setIsDirty,
  currentGene
}) => {
  const { allowRoute, roles } = useSelector((state) => state.auth);
  const isViewMode = mode === MODE_SCREEN.VIEW;
  const handleDeleteRow = (key) => {
    const newDataSource = dataSource.filter((item) => {
      return item.key !== key;
    });
    setDataSource(newDataSource);
    setIsDirty(true)
  };
   const getGene = () => {
    if(mode === MODE_SCREEN.ADD)return 1;
    return currentGene
    }
  const onChangeFiledInputColum = (key, nameColums, newValue) => {
    const index = dataSource.findIndex((item) => item.key === key);
    const newObject = {
      [nameColums]: newValue,
    };

    if (nameColums === "inputFormat") {
      newObject["unit"] = "";
      newObject["selection"] = "";
      if (newValue !== COMMON_CONSTANT.INPUT_FORMAT_NUM) {
        newObject["controlValueLow"] = "";
        newObject["controlValueUpper"] = "";
        newObject["easyDriveLow"] = "";
        newObject["easyDriveUpper"] = "";
      }
    }
    const newDataSource = [
      ...dataSource.slice(0, index),
      { ...dataSource[index], ...newObject },
      ...dataSource.slice(index + 1),
    ];
    setDataSource(newDataSource);
    setIsDirty(true)
  };
  const handleAddRow = () => {
    const key = Date.now();
    const newRow = {
      key,
      checkItemName: "",
      controlValueLowe: "",
      controlValueUpper: "",
      easyDriveLow: "",
      easyDriveUpper: "",
      inputFormat: "",
      unit: "",
      selection: "",
      inspectionFryquency: "",
      generationNumber:getGene()
    };
    setDataSource([...dataSource, newRow]);
  };
  const isReadOnlyRole = roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER";
  const isError = (data, {generationNumber,...row}) =>
    isEmptyData(data) && clickSave && filterEmptyDataSource(row);
  const columns = [
    !isViewMode && {
      title: " ",
      dataIndex: "delete",
      width: "5%",
      render: (_, row) => (
        <Button
          disabled={row.isUsed}
          style={{ background: "#f7f9fc" }}
          onClick={() => handleDeleteRow(row.key)}
          icon={<DeleteOutlined />}
          hidden={isReadOnlyRole}
        />
      ),
    },
    {
      title: (
        <span style={{ color: "#ff2255" }}>{lang.INSPECTION_TIME_NAME}</span>
      ),
      dataIndex: "checkItemName",
      width: "20%",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.checkItemName}</span>
        ) : (
          <Input
            value={row.checkItemName}
            className={isError(_, row) ? STYLE.BORDER_RED : ""}
            onChange={(e) =>
              onChangeFiledInputColum(row.key, "checkItemName", e.target.value)
            }
            disabled={isReadOnlyRole}
          />
        ),
    },

    {
      title: (
        <span>
          警報値
          <br />
          (下)
        </span>
      ),
      dataIndex: "controlValueLow",
      width: "9%",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.controlValueLow}</span>
        ) : (
          <Input
            type="number"
            value={row.controlValueLow}
            onChange={(e) =>
              onChangeFiledInputColum(
                row.key,
                "controlValueLow",
                e.target.value
              )
            }
            disabled={
              isReadOnlyRole ||
              row.inputFormat !== COMMON_CONSTANT.INPUT_FORMAT_NUM
            }
          />
        ),
    },

    {
      title: (
        <span>
          警報値
          <br />
          (上)
        </span>
      ),
      dataIndex: "controlValueUpper",
      width: "9%",
      align: "center",

      render: (_, row) =>
        isViewMode ? (
          <span>{row.controlValueUpper}</span>
        ) : (
          <Input
            type="number"
            value={row.controlValueUpper}
            onChange={(e) =>
              onChangeFiledInputColum(
                row.key,
                "controlValueUpper",
                e.target.value
              )
            }
            disabled={
              isReadOnlyRole ||
              row.inputFormat !== COMMON_CONSTANT.INPUT_FORMAT_NUM
            }
          />
        ),
    },

    {
      title: (
        <span>
          運転めやす
          <br />
          (下)
        </span>
      ),
      dataIndex: "easyDriveLow",
      width: "9%",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.easyDriveLow}</span>
        ) : (
          <Input
            type="number"
            value={row.easyDriveLow}
            onChange={(e) =>
              onChangeFiledInputColum(row.key, "easyDriveLow", e.target.value)
            }
            disabled={
              isReadOnlyRole ||
              row.inputFormat !== COMMON_CONSTANT.INPUT_FORMAT_NUM
            }
          />
        ),
    },

    {
      title: (
        <span>
          運転めやす
          <br />
          (上)
        </span>
      ),
      dataIndex: "easyDriveUpper",
      width: "9%",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.easyDriveUpper}</span>
        ) : (
          <Input
            disabled={
              isReadOnlyRole ||
              row.inputFormat !== COMMON_CONSTANT.INPUT_FORMAT_NUM
            }
            type="number"
            value={row.easyDriveUpper}
            onChange={(e) =>
              onChangeFiledInputColum(row.key, "easyDriveUpper", e.target.value)
            }
          />
        ),
    },

    {
      title: <span style={{ color: "#ff2255" }}>{lang.INPUT_FORMAT}</span>,
      dataIndex: "inputFormat",
      width: "9%",
      align: "center",

      render: (_, row) =>
        isViewMode ? (
          <span>{row.inputFormat}</span>
        ) : (
          <Select
            className={(isError(_, row) ? STYLE.BORDER_RED : "") + " w100"}
            value={row.inputFormat}
            onChange={(v) => onChangeFiledInputColum(row.key, "inputFormat", v)}
            disabled={isReadOnlyRole}
          >
            {renderOption(inputFormatOptions, false)}
          </Select>
        ),
    },

    {
      title: lang.UNIT,
      dataIndex: "unit",
      align: "center",

      width: "10%",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.unit}</span>
        ) : (
          <Input
            value={row.unit}
            onChange={(e) =>
              onChangeFiledInputColum(row.key, "unit", e.target.value)
            }
            disabled={
              isReadOnlyRole || !["文字", "数字"].includes(row.inputFormat)
            }
          />
        ),
    },

    {
      title: (
        <Tooltip title={"選択肢の間に「;」（半角）を入力します。"}>
          <span>{lang.SELECTION}</span>
        </Tooltip>
      ),
      dataIndex: "selection",
      width: "10%",
      align: "center",

      render: (_, row) =>
        isViewMode ? (
          <span>{row.selection}</span>
        ) : (
          <Tooltip title={"選択肢の間に「;」（半角）を入力します。"}>
            <Input
              value={row.selection}
              onChange={(e) =>
                onChangeFiledInputColum(row.key, "selection", e.target.value)
              }
              disabled={isReadOnlyRole || row.inputFormat !== "選択"}
            />
          </Tooltip>
        ),
    },

    {
      title: (
        <span style={{ color: "#ff2255" }}>{lang.INSPECTION_FREQUENCY}</span>
      ),
      dataIndex: "inspectionFryquency",
      width: "7%",
      align: "center",

      render: (_, row) =>
        isViewMode ? (
          <span>{row.inspectionFryquency}</span>
        ) : (
          <Select
            className={(isError(_, row) ? STYLE.BORDER_RED : "") + " w100"}
            value={row.inspectionFryquency}
            onChange={(v) =>
              onChangeFiledInputColum(row.key, "inspectionFryquency", v)
            }
            disabled={isReadOnlyRole}
          >
            {renderOption(inspectionFryquencyOptions, false)}
          </Select>
        ),
    },
  ].filter(Boolean);

  return (
    <div>
      <Table
        scroll={dataSource && dataSource.length > 0 && { y: 610, x: 768 }}
        locale={{
          emptyText: "",
        }}
        pagination={false}
        dataSource={dataSource}
        className="tableAddMachine"
        columns={columns}
      />
      {mode !== MODE_SCREEN.VIEW && (
        <Button
          style={{
            background: "#f7f9fc",
            width: "auto",
            minWidth: "auto",
          }}
          hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
          className="pr10 pl10 mt4 mb4 ml10"
          onClick={() => handleAddRow()}
          icon={<PlusOutlined />}
        ></Button>
      )}
    </div>
  );
};

export default EquipmentListItem;
